import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { PHARMACY_INVOICE_FROM, PHARMACY_PRODUCT_TYPE, PHARMACY_PRODUCT_TYPE_MENUS, PHARMACY_SUPPLIER } from '../../../../../constants/dropdown';
import { PHARMACY_TYPE_MENUS } from '../../../../../constants/dropdown';
import { AddDetails } from '../PurchaseTransaction/AddDetails';
import { dateFormatter } from '../../../../../utils';



const TAX_SUMMARY_HEADER = [
    { header: 'GST%', accessor: 'gst' },
    { header: 'Taxable Amount', accessor: 'taxable' },
    { header: 'CGST Amt', accessor: 'cgst' },
    { header: 'SGST Amt', accessor: 'sgst' },
    { header: 'IGST Amt', accessor: 'igst' },

];

const PATIENT_TABLE_HEADER = [
    { header: 'UHID', accessor: 'uhid' },
    { header: 'OP No', accessor: 'op_no' },
    { header: 'Created At', accessor: 'createdAt' },
    { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name}` },
    { header: 'Mobile No', accessor: 'address.mobile' },
    { header: 'Doctor', accessor: 'consultant.name' },
    { header: 'Address', accessor: 'address.address' }
];

const TABLE_HEADER = [
    {
        header: 'CNT No',
        accessor: 'cnt'
    },
    {
        header: 'CNT Type',
        accessor: 'type'
    },
    {
        header: 'CNT Date',
        accessor: (row) => `${getCurrentDateTime('date', row.cnt_date)}`
    },
    {
        header: 'Product Type',
        accessor: 'type'
    },
    {
        header: 'Location',
        accessor: (row) => row?.location?.warehouse_name
    },
    {
        header: 'Supplier Name',
        accessor: 'supplier'
    },
    {
        header: 'Invoice No',
        accessor: 'invoice_no'
    },
    {
        header: 'Net Amount',
        accessor: 'net_amt'
    },
    {
        header: 'Created At',
        accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
    },
    {
        header: 'Status',
        accessor: 'status',
        sx: { textTransform: 'uppercase' }
    }
];

const initialConsignmentDataObj = {
    data: [],
    loading: false
};

export const SaleReturn = () => {
    const { pathname } = useLocation();
    const lastPathSegment = pathname.split('/').pop();
    const [detailList, setDetailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [consignmentDataObj, setConsignmentDataObj] = useState(initialConsignmentDataObj);
    const [openQueryDialog, setOpenQueryDialog] = useState(false);
    const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
    const [patientDetailList, setPatientDetailList] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [input, setInput] = useState('');
    const [isFiltered, setIsFiltered] = useState(false);
    const [patientDataList, setPatientDataList] = useState([])
    const [warehouse, setWareHosue] = useState([])
    const [addtcdDialogue, setAddtcdDialogue] = useState(false)
    const [addDetailsDialogue, setAddDetailsDialogOpen] = useState(false)

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                invoice_no: Yup.string().required(' '),
                invoice_from: Yup.string().required(' '),
            })
        ),
        defaultValues: {
            date: getCurrentDateTime('date'),
            time: getCurrentDateTime('time'),
            bill: {
                out_sourced: 'No',
                // rec_amt_1: 0,
                // rec_amt_2: 0,
                tds_amt: 0,
                disc_amt: 0,
                gst_amt: 0,
                net_amt: 0
            }
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;
    const column = watch('view_column')

    const BILL_TABLE_HEADER = [
        { header: 'InvoiceNo.', accessor: 'inv_no' },
        { header: 'Product Name', accessor: "product" },
        { header: 'Batch No', accessor: 'batch_no' },
        { header: 'Exp Date', accessor: 'exp_date' },
        { header: 'Billed Qty', accessor: 'billed_qty' },
        column ? { header: 'Free Qty', accessor: 'free_qty' } : null,
        column ? { header: 'Total Qty', accessor: 'total_qty' } : null,
        { header: 'Return Qty', accessor: 'return_qty' },
        { header: 'Free Ret. Qty', accessor: 'free_ret_qty' },
        column ? { header: 'Total Ret. Qty', accessor: 'total_ret_qty' } : null,
        { header: 'Unit', accessor: 'unit' },
        { header: 'Rate', accessor: 'rate' },
        { header: 'Amount', accessor: 'amt' },
        { header: 'Dis Amt', accessor: 'dis_amt' },
        { header: 'Taxable', accessor: 'taxable' },
        { header: 'Gst%', accessor: 'gst' },
        column ? { header: 'Cgst', accessor: 'cgst' } : null,
        column ? { header: 'Sgst', accessor: 'sgst' } : null,
        column ? { header: 'Igst', accessor: 'igst' } : null,
        {
            header: 'Net Amount',
            accessor: "net_amt"
        }
    ].filter(Boolean);

    useEffect(() => {
        let total_qty = 0;
        let total_amt = 0;
        let disc_amt = 0;
        let net_amt = 0;
        let gst_amt = 0;

        detailList.forEach((detail) => {
            total_qty += detail.rec_qty;
            total_amt += detail.amount;
            disc_amt += detail.disc_amt;
            gst_amt += detail.gst_amt;
            net_amt += detail.net_amt;
        });

        // Round net_amt to the nearest integer
        const roundedNetAmt = Math.round(net_amt);

        // Calculate the round off difference (original net_amt - rounded net_amt)
        const roundOff = parseFloat((net_amt - roundedNetAmt).toFixed(2));

        // Set the calculated values
        setValue('total_qty', total_qty);
        setValue('total_amt', total_amt);
        setValue('disc_amt', disc_amt);
        setValue('gst_amt', gst_amt);
        setValue('net_amt', roundedNetAmt); // Set the rounded value as net_amt
        setValue('round_off', Math.abs(roundOff));  // Set the absolute value of the round off difference
    }, [detailList, setValue]);

    const netAmtWatch = watch('bill.net_amt');
    const recAmt1Watch = watch('bill.rec_amt_1');
    const recAmt2Watch = watch('bill.rec_amt_2');
    const payMode = watch('bill.pay_mode');

    useEffect(() => {
        const total_recpt = +recAmt1Watch + +recAmt2Watch;
        let balanceAmt = netAmtWatch - total_recpt;
        if (payMode === "CASH") {
            setValue('bill.rec_amt_1', netAmtWatch);
            setValue('bill.rec_amt_2', 0);
            setValue('bill.balance_amt', 0);
            setValue('bill.total_recpt', netAmtWatch);
        } else if (["Bank", "UPI", "Paytm", "RTGS/NEFT/Cheque", "Credit Card", "Debit Card"].includes(payMode)) {
            setValue('bill.rec_amt_1', 0);
            setValue('bill.rec_amt_2', netAmtWatch);
            setValue('bill.balance_amt', 0);
            setValue('bill.total_recpt', netAmtWatch);
        } else {
            setValue('bill.total_recpt', total_recpt);
            setValue('bill.balance_amt', balanceAmt);
        }
    }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);





    useEffect(() => {
        if (selectedRecord) {
            const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
                '__v',
                '_id',
                'createdAt',
                'status',
                'add_details',
                'uhid'
            ]);
            keyValuePair.forEach(({ key, value }) => setValue(key, value));
            setDetailList(selectedRecord.add_details);
            setValue('invoice_no', selectedRecord?.invoice_no)
            setValue('cnt', selectedRecord?.cnt)
            const formattedCrnDate = selectedRecord?.cnt_date
                ? new Date(selectedRecord.cnt_date).toISOString().split('T')[0]
                : '';
            setValue('cnt_date', formattedCrnDate);
            const formattedInvoiceDate = selectedRecord?.invoice_date
                ? new Date(selectedRecord.invoice_date).toISOString().split('T')[0]
                : '';
            setValue('invoice_date', formattedInvoiceDate);
            setValue('type', selectedRecord?.type)
            setValue('supplier', selectedRecord?.supplier)
            setValue('location', selectedRecord?.location?._id)
            setValue('product_type', selectedRecord?.product_type)
            setValue('invoice_from', selectedRecord?.invoice_from)
            setValue('amd_no', selectedRecord?.amd_no)
            setValue('remarks', selectedRecord?.remarks)
            setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
            setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
        } else {
            reset();
        }
    }, [selectedRecord]);

    const formSubmit = async (formValues) => {
        if (detailList.length === 0) {
            toast('Please add the Details first', { variant: 'warning' });
            return;
        }
        setLoading(true);
        const payload = { ...formValues, add_details: detailList };
        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }
        const response = await request(editFlag ? '/consignment-receipt-update' : '/consignment-receipt-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: payload
        });
        console.log(response, "HELLO RESPONSE")
        if (response?.success && response.data) {
            toast(`Successfully ${editFlag ? 'edited' : 'created'} Consignment Receipt`, { variant: 'success' });
            setSelectedRecord(response?.data);
            setCurrentAction();
        } else {
            toast(`Failed to ${editFlag ? 'edit' : 'create'} Consignment Receipt`, { variant: 'error' });
        }
        setLoading(false);
    };

    const handleRowDelete = (rowId) => {
        setDetailList((prev) => prev.filter((data) => {
            return data.product !== rowId;
        }));
    };

    const onDetailAddHandler = (data) => {
        if (detailList.some((detail) => detail.product === data.product)) {
            toast('Same Product already taken.', { variant: 'error' });
        } else {
            setDetailList((prev) => [...prev, { ...data }]);
            console.log("HELLO PRODUCT LIST ITME S", detailList)
        }
    };

    const handleDeleteRecord = async () => {
        setLoading(true);
        const response = await request('/consignment-receipt-delete', {
            method: 'DELETE',
            params: selectedRecord._id
        });
        if (response?.success) {
            toast('Successfully deleted Consignment Receipt', { variant: 'success' });
            setSelectedRecord();
        } else {
            toast('Failed to delete Consignment Receipt', { variant: 'error' });
        }
        setLoading(false);
    };

    const handleQueryWindow = async () => {
        setOpenQueryDialog(true);
        setConsignmentDataObj({ loading: true });
        const response = await request('/consignment-receipt-list', { method: 'GET' });
        if (response.success) {
            const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setConsignmentDataObj({ loading: false, data: response.data });
            setOriginalData(sortedData)
        } else {
            toast('Error in fetching data', { variant: 'error' });
            setConsignmentDataObj({ loading: false });
        }
    };



    useEffect(() => {
        if (consignmentDataObj.data && consignmentDataObj.data.length > 0) {
            setOriginalData(consignmentDataObj.data);
            setIsFiltered(false);
        }
    }, [consignmentDataObj.data]);

    const handleUhidSearch = () => {
        const lowercasedInput = input.toLowerCase();
        const filtered = consignmentDataObj.data.filter((item) =>
            item.invoice_no?.toString().toLowerCase().includes(lowercasedInput)
        );
        setOriginalData(filtered);
    };

    const handleChange = (e) => {
        const newInput = e.target.value;
        setInput(newInput);
        handleUhidSearch();
    };

    const getWarehouseDropdown = useCallback(async () => {
        const data = await dropdownFetch('warehouse');
        setWareHosue(data);
    }, []);
    useEffect(() => {
        getWarehouseDropdown()
    }, [getWarehouseDropdown])

    return (
        <>
            <Paper sx={{
                p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
                width: '100%',
                height: 'auto',
                maxWidth: '100vw',
                minHeight: '100vh'
            }}>
                <Container
                    sx={{
                        mt: 2,
                        p: 0.2,
                        border: '1px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                pb: 0.5,
                                mb: 3,
                                borderBottom: '1px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                                Sale Return
                            </Typography>
                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <CustomButtonn
                                    id={`${lastPathSegment}Write`}
                                    variant="contained"
                                    disabled={['edit', 'new'].includes(currentAction)}
                                    onClick={() => {
                                        setSelectedRecord();
                                        setCurrentAction('new');
                                        setDetailList([])
                                        reset()
                                    }}
                                >
                                    New
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Update`}
                                    variant="contained"
                                    disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                                    onClick={() => setCurrentAction('edit')}
                                >
                                    Edit
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Submit"}
                                    type="submit"
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                >
                                    Save
                                </CustomButtonn>
                                <CustomButtonn
                                    id={"Cancel"}
                                    variant="contained"
                                    disabled={!['edit', 'new'].includes(currentAction) || loading}
                                    onClick={() => {
                                        setCurrentAction();
                                    }}
                                >
                                    Cancel
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`isSuperAdmin`}
                                    variant="contained"
                                    disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                                    onClick={handleDeleteRecord}
                                >
                                    Delete
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Read`}
                                    variant="contained"
                                    onClick={handleQueryWindow}
                                    disabled={['new', 'edit'].includes(currentAction)}
                                >
                                    Query
                                </CustomButtonn>
                                <CustomButtonn
                                    id={`${lastPathSegment}Print`}
                                    variant="contained"
                                    onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                                    disabled={!selectedRecord || currentAction}
                                >
                                    Print
                                </CustomButtonn>
                                <CustomButtonn id={"Exit"} variant="contained">Exit</CustomButtonn>
                            </Stack>
                        </Stack>
                        <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: "1.4rem" }}>Inv No.</Typography>
                                <TextField disabled sx={{ flex: 0.3 }} name="inv_no" />
                                <TextField disabled sx={{ flex: 0.1 }} name="inv" />
                                <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: "1.4rem" }}>Inv Date</Typography>
                                <TextField disabled sx={{ flex: 0.3 }} name="date" placeholder="Inv Date" />
                            </Stack>
                            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: "1.4rem" }}>Location</Typography>
                                <SelectTag disabled={!['new', 'edit'].includes(currentAction)} formControlSX={{ flex: 0.4 }} name="location" placeholder="Location" menus={warehouse.map((data) => ({ ...data, name: data.warehouse_name }))} />
                                <Typography sx={{ flex: 0.22, fontWeight: 700, fontSize: "1.4rem" }}>Remarks</Typography>
                                <TextField disabled={!['new', 'edit'].includes(currentAction)} sx={{ flex: 0.4 }} name="remarks" placeholder="Remarks" />
                            </Stack>
                        </Stack>
                        <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.19, fontWeight: 700, fontSize: "1.4rem" }}>Customer</Typography>
                                <SelectTag disabled={!['new', 'edit'].includes(currentAction)} formControlSX={{ flex: 0.9 }} name="customer" menus={PHARMACY_SUPPLIER} placeholder="Select Customer" />
                            </Stack>
                            <Stack sx={{ flex: 1 / 2 }} spacing={0.5} direction="row" alignItems="center">
                                <Typography sx={{ flex: 0.18, fontWeight: 700, fontSize: "1.4rem" }}>Deli. Customer</Typography>
                                <SelectTag disabled={!['new', 'edit'].includes(currentAction)} formControlSX={{ flex: 0.85 }} name="deli_customer" placeholder="Deli. Customer " menus={PHARMACY_INVOICE_FROM} />
                            </Stack>
                        </Stack>

                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, minHeight: '30rem' }}>
                            <Stack spacing={1} direction="row" justifyContent="space-between">
                                <Button
                                    variant="contained"
                                    disabled={!['new', 'edit'].includes(currentAction)}
                                    onClick={() => setAddDetailsDialogOpen(true)}
                                >
                                    Select Sales Invoice No.
                                </Button>
                                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 2 }}>
                                    <Checkbox
                                        formControlSX={{ flex: 0.8 }}
                                        name="view_column"
                                        disabled={!['new', 'edit'].includes(currentAction)}
                                        fontSize={18}
                                    />
                                    <Typography sx={{ flex: 0.4, fontWeight: 600 }}>View All Columns in Table</Typography>
                                </Stack>
                            </Stack>
                            <Table
                                containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                                data={detailList.map((data) => ({ _id: data.product, ...data }))}
                                columns={BILL_TABLE_HEADER}
                                size="small"
                                showDeleteAction={true}
                                onDeleteHandler={handleRowDelete}
                            />
                        </Grid>
                        <Stack sx={{ mb: 0.3 }} direction="row" spacing={2} minHeight={"5rem"}>
                            <Table
                                containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                                data={detailList || []}
                                columns={TAX_SUMMARY_HEADER}
                                size="small"
                                onDeleteHandler={handleRowDelete}
                            />

                            <Stack sx={{ flex: 1 }} spacing={0.5} direction="column">
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: "1.4rem" }}> Qty</Typography>
                                    <TextField
                                        disabled
                                        sx={{ flex: 0.7 }}
                                        name="qty"
                                    />
                                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: "1.4rem" }}>Return Qty</Typography>
                                    <TextField
                                        disabled
                                        sx={{ flex: 0.7 }}
                                        name="return_qty"
                                    />
                                </Stack>
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: "1.4rem" }}>Total Amt</Typography>
                                    <TextField
                                        disabled
                                        sx={{ flex: 0.7 }}
                                        name="total_amount"
                                    />
                                    <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: "1.4rem" }}>Round Off</Typography>
                                    <TextField
                                        disabled
                                        sx={{ flex: 0.7 }}
                                        name="round_off"
                                    />
                                </Stack>
                                {/* Net Amount */}
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <Typography sx={{ flex: 0.17, fontWeight: 700, fontSize: "1.4rem" }}>Net Amount</Typography>
                                    <TextField
                                        disabled
                                        sx={{ flex: 1 }}
                                        name="net_amt"

                                    />
                                </Stack>
                            </Stack>
                        </Stack>
                    </FormProvider>
                </Container>
            </Paper >

            <Dialog
                open={openQueryDialog}
                onClose={() => setOpenQueryDialog(false)}
                PaperProps={{ sx: { width: '80%', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <Stack
                    padding={1.5}
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="grey.300"
                >
                    <Typography variant="h4" fontWeight="bold">
                        Sales Return Query Window
                    </Typography>
                    <IconButton onClick={() => setOpenQueryDialog(false)}>
                        <CloseIcon color="error" fontSize="large" />
                    </IconButton>
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
                    <MuiTextField
                        sx={{ width: '100%', padding: 0 }}
                        label="Search Consignment Receipt"
                        variant="outlined"
                        value={input}
                        onChange={handleChange}
                    />
                </Stack>
                <Table
                    sx={{ mt: 3 }}
                    columns={TABLE_HEADER}
                    data={originalData || []}
                    loading={consignmentDataObj.loading}
                    onRowClick={(row) => {
                        delete row.patient;
                        setSelectedRecord(row);
                        setOpenQueryDialog(false);
                    }}
                />
            </Dialog>
            <Dialog
                open={addDetailsDialogue}
                onClose={() => setAddDetailsDialogOpen(false)}
                PaperProps={{ sx: { width: '80%', height: '100vh', p: 2 } }}
                maxWidth="xl"
                scroll="body"
            >
                <AddDetails
                    onClose={() => setAddDetailsDialogOpen(false)}
                    onAdd={onDetailAddHandler}
                />
            </Dialog>
        </>
    );
};
